// 公司主要股东信息，创始人信息等配置


const avatars = {
    zhouyang: require('../../../assets/images/boss-zhouyang.png'),
    daitao: require('../../../assets/images/boss-daitao.png'),
    lixuntao: require('../../../assets/images/boss-lixuntao.png'),
    qingzhengjun: require('../../../assets/images/boss-qingzhengjun.png'),
    shenhuarong: require('../../../assets/images/boss-shenhuarong.png'),
    xuliping: require('../../../assets/images/boss-xuliping.png'),
    zhangyuhua: require('../../../assets/images/boss-zhangyuhua.png'),
    liliang: require('../../../assets/images/boss-liliang.png'),
    liqiang: require('../../../assets/images/boss-liqiang.png'),
    zhangjing: require('../../../assets/images/boss-zhangjing.png'),
    haojinsheng: require('../../../assets/images/boss-haojinsheng.png'),
};


// 董事长
export const CHAIRMAN_BOSS = {
    name: '钟明',
    avatar: require('../../../assets/images/boss-big.png'),
    contents: [
        '基准方中发起创始人、董事长、无党派人士',
        '第十三届四川省政协委员、成都市工商联副会长',
        '1982年毕业于同济大学建筑学专业',
    ],
}; 


// 其它boss或股东
export const SHAREHOLDER_BOSS = [
    {
        name: '周颿',
        avatar: avatars.zhouyang,
        titles: ['基准方中联合创始人、总建筑师'],
        contents: [
            '国家一级注册建筑师、高级工程师',
            '四川省住房和城乡建设厅专家库专家',
            '1989年毕业于东南大学建筑系',
        ],
    },
    {
        name: '章玉华',
        avatar: avatars.zhangyuhua,
        titles: ['基准方中联合创始人、总经理'],
        contents: [
            '1994年毕业于同济大学工业与民用建筑专业',
            '国家一级注册结构工程师',
            '成都市青羊区人大代表、中国勘察设计协会民营企业分会副会长',
        ],
    },
    {
        name: '戴涛',
        avatar: avatars.daitao,
        titles: ['基准方中联席CEO、董事'],
        contents: [
            '国家一级注册建筑师，教授级高工、英国皇家特许建筑师',
            '成都市青羊区政协委员、成都市青羊区工商业联合会（总商会）副会长',
            '1995年毕业于浙江大学建筑学专业',
        ],
    },
    {
        name: '李迅涛',
        avatar: avatars.lixuntao,
        titles: ['基准方中董事、首席总建筑师'],
        contents: [
            '国家一级注册建筑师、教授级高工',
            '中国建筑学会首届居住建筑专业委员会委员',
            '成都市锦江区人大代表、四川省住房和城乡建设厅专家库专家',
            '成都市房屋建筑工程勘察设计专家库专家',
            '2004年加入基准方中',
        ],
    },
    {
        name: '沈华荣',
        avatar: avatars.shenhuarong,
        titles: ['基准方中董事'],
        contents: [
            '国家一级注册设备工程师、高级工程师',
            '西安市勘察设计协会副理事长',
            '1985年毕业于重庆建筑工程学院给水与排水专业',
            '2007年加入基准方中',
        ],
    },
    {
        name: '秦正军',
        avatar: avatars.qingzhengjun,
        titles: ['基准方中董事、执行总建筑师'],
        contents: [
            '国家一级注册建筑师、高级工程师',
            '成都市绿色建筑和装配式建筑专家',
            '成都市土木建筑学会绿色建筑学术委员会委员',
            '2003年毕业于西北工业大学建筑学专业',
            '2005年加入基准方中',
        ],
    },
    {
        name: '许立平',
        avatar: avatars.xuliping,
        titles: ['基准方中董事会秘书、副总经理、财务总监'],
        contents: [
            '四川省县域经济学会城镇发展工作委员会副理事长、高级经济师',
            '1989年毕业于厦门大学金融学专业',
            '2014年加入基准方中',
        ],
    },
    {
        name: '张菁',
        avatar: avatars.zhangjing,
        titles: ['基准方中党委副书记、监事长' ,'审计监察中心主任、人力与行政管理中心总经理'],
        contents: [
            '国家一级注册建筑师、高级工程师、英国皇家特许建筑师',
            '中国勘察设计协会第七届理事、成都市勘察设计协会副理事长兼秘书长',
            '中共成都市社会组织第三综合委员会委员、青羊区总工会兼职副主席',
            '2003年加入基准方中',
        ],
    },
    {
        name: '郝晋升',
        avatar: avatars.haojinsheng,
        titles: ['基准方中董事副总经理'],
        contents: [
            '国家一级注册建筑师、国家一级注册结构工程师、正高级工程师',
            '哈尔滨工业大学硕士研究生',
            '2005年加入基准方中',
        ],
    },
    {
        name: '李强',
        avatar: avatars.liqiang,
        titles: ['基准方中首席总建筑师'],
        contents: [
            '国家一级注册建筑师、高级工程师',
            '1986年毕业于华南理工大学建筑学专业',
            '2004年加入基准方中',
        ],
    },
    {
        name: '黎亮',
        avatar: avatars.liliang,
        titles: ['基准方中首席总建筑师'],
        contents: [
            '成都市锦江区政协委员、四川省体育场馆协会专家',
            '1992年毕业于苏州科技大学城市规划专业',
            '2007年加入基准方中',
        ],
    },
];